<template>
  <div class="create">
    <el-steps
      :active="active"
      align-center
    >
      <el-step title="手机号码" />
      <el-step title="完善信息" />
    </el-steps>
    <div class="form-panel">
      <createStep1From
        v-if="active === 1"
        @next="next1"
      />
      <createStep2From
        v-if="active === 2"
        :info="stpe1Data"
        :form="stpe2Data"
        @prev="prev"
        @next="next2"
      />
    </div>
  </div>
</template>
<script>

import axClient from '@/services';
import createStep1From from './form/creatStep1.vue';
import createStep2From from './form/creatStep2.vue';

export default {
  name: 'CaseEdit',
  components: {
    createStep1From,
    createStep2From,
  },
  data() {
    return {
      active: 1,
      stpe1Data: {},
      stpe2Data: {},
      isEditType: !!this.$route.params.id,
      data: {},
    };
  },
  mounted() {
    this.isEdit();
  },
  methods: {
    prev(active) {
      this.active = active;
    },
    // 第一步
    next1(data) {
      this.stpe1Data = data;
      this.active = 2;
    },
    // 第二步
    next2(data) {
      this.stpe2Data = data;
      this.submit();
    },
    // 提交
    async submit() {
      const { userId } = this.stpe1Data;
      const {
        courseId,
        agencyId,
      } = this.stpe2Data;
      const data = await axClient.registration.registrationInsertBackend({
        userId,
        courseId,
        agencyId,
      });
      if (data) {
        this.$message.success('新增报名成功');
        this.$router.push({ name: 'RegistrationList' });
      }
    },
    // 是否编辑信息
    async isEdit() {
      if (this.isEditType) {
        // 编辑
        this.data = await axClient.counselor.getDetail({ id: this.$route.params.id });
        const {
          counselorMobilePhone, userId, counselorUserRealName,
          wechatAvatarUrl, certificatePic, qualificationPic, skillsPic, courseList,
        } = this.data;
        this.stpe1Data = {
          userId,
          mobilePhone: counselorMobilePhone,
          wechatAvatarUrl,
          realName: counselorUserRealName,
        };
        this.stpe2Data = {
          certificatePic,
          qualificationPic,
          skillsPic,
          courseList: courseList.map((v) => v.courseClassId),
        };
        this.active = 2;
      }
    },
  },
};
</script>